'use client';

import React from 'react';
import Link from 'next/link';
import { AtHeader, AtText, AtTag } from '@/components/atoms';
import type { IHomePlanProps } from './ml-card.types';
import { sendHomePlanClickGTMEvent } from '@/components/helpers/analytics/gtm';

export default function HomePlanBody({
  name,
  description,
  features,
  tags,
  href,
  headerElement = 'h4',
  id,
}: IHomePlanProps) {
  const handleClick = async () => {
    sendHomePlanClickGTMEvent(name, id, href || '');
  };

  return (
    <div
      className="mx-4 w-[calc(100%-2rem)]"
      data-testid="ml-card-home-plan-body"
    >
      {href ? (
        <Link href={href} className="expandCoverage" onClick={handleClick}>
          <AtHeader element={headerElement} variant="h4" className="mb-1">
            {name}
          </AtHeader>
        </Link>
      ) : (
        <AtHeader element={headerElement} variant="h4" className="mb-1">
          {name}
        </AtHeader>
      )}
      <AtText type="p" className="">
        {description}
      </AtText>
      <ul className="mb-[1.125rem] flex">
        {features.map((feature, i) => (
          <li
            key={`${feature}_${i}`}
            className='text-11 font-semibold uppercase text-skin-disabled after:mx-2 after:content-["|"] last:after:content-[""] lg:text-18 lg:text-base'
          >
            {feature}
          </li>
        ))}
      </ul>
      <ul className="flex gap-4">
        {tags.map(({ variant, children, size }, i) => (
          <li key={`${children}_${i}`}>
            <AtTag variant={variant} size={size}>
              {children}
            </AtTag>
          </li>
        ))}
      </ul>
    </div>
  );
}
